import script from "./TableLineDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TableLineDetail.vue?vue&type=script&setup=true&lang=js"

import "./TableLineDetail.vue?vue&type=style&index=0&id=95a5a074&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95a5a074"]])

export default __exports__